import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import Modal from '@molecules/Modal/Modal'
import { useConfig } from 'msp-integrations'
import RequestPasswordForm from './RequestPasswordForm'

type RequestPasswordModalProps = {
  isOpen: boolean
  setOpen: (state: boolean) => void
  hideBodyOverflow?: boolean
}

const RequestPasswordModal = ({
  isOpen,
  setOpen,
  hideBodyOverflow = true
}: RequestPasswordModalProps) => {
  const { formatMessage } = useIntl()
  const [emailSent, setEmailSent] = useState<boolean>(false)
  const {
    theme: {
      font,
      mspComponents: { requestPasswordModal }
    }
  } = useConfig()

  const closeModal = () => {
    setOpen(false)
    setEmailSent(false)
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeModal}
      overlay={true}
      closeOnOverlayClick={true}
      modalHeader={
        !emailSent ? (
          <ModalHeader
            header={requestPasswordModal?.header}
            detail={requestPasswordModal?.detail}
          />
        ) : undefined
      }
      style={`${font.regular} !w-screen md:!w-[80vw] md:max-w-[820px] px-10 pt-12 pb-16`}
      hideBodyOverflow={hideBodyOverflow}
      modalBody={
        emailSent ? (
          <p className='text-16'>
            {formatMessage({
              defaultMessage: 'Please check your email account.',
              id: 'resetPasswordModal.emailSent'
            })}
          </p>
        ) : (
          <RequestPasswordForm
            className='px-10 md:px-[10vw] 2xl:px-[5vw]'
            onSubmit={() => setEmailSent(true)}
            onClose={closeModal}
          />
        )
      }
    />
  )
}

const ModalHeader = ({
  header,
  detail
}: {
  header?: string
  detail?: string
}) => {
  const { formatMessage } = useIntl()
  return (
    <>
      <h2 className={`text-36 leading-44 ${header} -mt-2`}>
        {formatMessage({
          defaultMessage: 'Password vergessen',
          id: 'resetPasswordModal.header'
        })}
      </h2>
      <p className={`text-16 ${detail} mb-8 mt-4`}>
        {formatMessage({
          defaultMessage:
            "Please, type your email address below and we'll send you a link to reset your password.",
          id: 'resetPasswordModal.subheader'
        })}
      </p>
    </>
  )
}

export default RequestPasswordModal
